import { NewContentInDto, NewContentOutDto } from '../../../types/content.dto'

export const NEW_CUSTOM_CONTENT_TYPE = 'NEW_CUSTOM_CONTENT_TYPE'
export const NEW_CUSTOM_CONTENT_TYPE_SUCCESS = 'NEW_CUSTOM_CONTENT_TYPE_SUCCESS'
export const NEW_CUSTOM_CONTENT_TYPE_ERROR = 'NEW_CUSTOM_CONTENT_TYPE_ERROR'
export const RESET_NEW_CUSTOM_CONTENT_TYPE = 'RESET_NEW_CUSTOM_CONTENT_TYPE'

export interface NewCustomContentType {
  type: typeof NEW_CUSTOM_CONTENT_TYPE
  payload: NewContentOutDto
}

export interface NewCustomContentTypeSuccess {
  type: typeof NEW_CUSTOM_CONTENT_TYPE_SUCCESS
  payload: NewContentInDto
}

export interface NewCustomContentTypeError {
  type: typeof NEW_CUSTOM_CONTENT_TYPE_ERROR
  payload: string | boolean
}

export interface ResetNewCustomContentType {
  type: typeof RESET_NEW_CUSTOM_CONTENT_TYPE
  payload: null
}

export interface State {
  data: NewContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | NewCustomContentType
  | NewCustomContentTypeSuccess
  | NewCustomContentTypeError
  | ResetNewCustomContentType
